export default __webpack_public_path__ + "static/media/nav_audio.8f3b10d4.svg";